import moment from 'moment';
export default {
	isSaved: false,
	isPqyLs: false,
	isPqyStaff: false, //PQYRG 생산품질 업무담당자(작성)
	isPqyReviewer: false, //PQYRV 생산품질 중간관리자(검토)
	isPqyAdmin: false, //PQYAP 생산품질 관리자(승인)
	powTourRgstScrId: '', // 공정순회검사 화면 ID(품명 클릭시 공정순회검사 화면으로 이동하기 위해 필요함)
	powTourSttsManagements: [],
	powLnList: [],
	mdvRplList: [],
	pgsStList: [],
	pgsStPtCdList: [], //진행상태 selectbox
	sndStList: [],
	rmkHistory: [],
	userEmail: '',
	detailForm: DETAIL_FORM(),
	popupSearchParams: POPUP_SEARCH_PARAMS(),
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	selectedRow: SELECTED_ROW(),
	rcptInfo: new Map(),
	rfpInfo: new Map(),
	rcptBcInfo: new Map(),
	rfpBcInfo: new Map()
};

function SEARCH_PARAMS() {
	return {
		powLnCd: '',
		strDt: moment().subtract(1, 'months').format('YYYY-MM-DD'),
		endDt: moment().format('YYYY-MM-DD'),
		powBttmInfmNo: '',
		lastYn: '', //최종보기
		psgStCd: '' //진행상태
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SELECTED_ROW() {
	return {
		rowType: '',
		powLnCd: '', //라인
		powLnNm: '', //라인명
		insnDd: '', //검사일
		insnDdView: '', //검사일(화면뷰)
		ipnNos: '', //검사차수
		insnPrvsCt: '', //검사항목수
		okPrvsCt: '', //적합항목수
		ngPrvsCt: '', //부적합항목수
		stblPro: '', //적합율(%)
		pprrId: '', //작성자id
		pprrNm: '', //작성자성명
		pprrDd: '', //작성일
		fileId: '', //첨부파일id
		rgnDt: '', //등록일자
		powBttmInfmNo: '', //이상통보서no
		pgsStCd: '', //이상통보서상태
		pgsStNm: '', //이상통보서상태명
		tableState: ''
	};
}

function POPUP_SEARCH_PARAMS() {
	return {
		insnDd: moment().format('YYYYMMDD'),
		powLnCd: '',
		ipnNos: '', //검사차수
		powBttmInfmNo: '',
		rfp: '',
		rcpt: ''
	};
}

function DETAIL_FORM() {
	return {
		powBttmInfmNo: '',
		powLnCd: '',
		powLnNm: '',
		insnDd: '',
		ipnNos: '', //검사차수
		incsPrvsIct: '',
		mdvRplCd: '',
		rplSbc: '',
		rplRqDd: '',
		powPrbmTitl: '',
		powPrbmSbc: '',
		powPrbmCaus: '',
		bttmMdvSbc: '',
		mdvDd: '',
		rplrId: '',
		rplrNm: '',
		rgnId: '',
		rgnDt: '',
		chgrId: '',
		chgrDt: '',
		affrPrcsId: '',
		pgsStCd: '',
		affrPrcsDt: '',
		affrScnCd: '',
		affrDspoId: '',
		rmk: '',

		powPrbmFileId: '', //이상 파일
		powPrbmFile: [], //추가한 파일
		powPrbmFileDb: [], //기존db에 저장된 파일

		powImg1FileId: '', //이상내용 이미지 첨부 1
		powImg1File: {}, //추가한 파일
		powImg1FileDb: {}, //기존db에 저장된 파일

		powImg2FileId: '', //이상내용 이미지 첨부 2
		powImg2File: {}, //추가한 파일
		powImg2FileDb: {}, //기존db에 저장된 파일

		powCausFileId: '', //원인 파일
		powCausFile: [], //추가한 파일
		powCausFileDb: [], //기존db에 저장된 파일

		/**이메일 정보 */
		emlSndNo: '',
		sndStCd: 'NSND',
		dsprId: '',
		dsprNm: '',
		rcptNm: '',
		rfpNm: '',
		dsprAdr: '',
		rcptAdr: '',
		rfpAdr: '',
		
		rcptBcNm: '',
		rfpBcNm: '',
		rcptBcAdr: '',
		rfpBcAdr: ''
	};
}

export { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW, POPUP_SEARCH_PARAMS, DETAIL_FORM };
